import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import ChestDermalPiercingImage from '../../Assets/Piercing Services/Chestsurfacepiercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function ChestDermalPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Chest Dermal Piercing UAE | 450 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Chest Dermal Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Chest Dermal Piercing 450 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={ChestDermalPiercingImage} alt="Chest Dermal Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Chest Dermal Piercing</h3>

          <p>
            Enhance your body aesthetics with our professional chest dermal piercing services in the UAE, available at a premium yet affordable price of 450 AED. Chest dermal piercing is a stunning surface piercing that sits flat against the skin, creating the appearance of a single, elegant jewel embedded on the chest. This unique and modern piercing style offers a sophisticated way to adorn your skin, making it a popular choice for individuals who want a minimal yet eye-catching look. Whether you prefer a subtle crystal or a decorative top, chest dermal piercing provides a versatile and stylish option that beautifully complements your personal style.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and precision are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each chest dermal piercing with exceptional care and accuracy. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Dermal piercings require specialized techniques, and our experienced specialists are trained to perform the procedure carefully, ensuring proper placement and long-lasting results while minimizing discomfort.
          </p>

          <p>
            Chest dermal piercing is ideal for individuals who want a bold yet refined body modification that stands out in a subtle and elegant way. Its flat, surface-level design allows it to blend seamlessly with the skin while still drawing attention with its unique appearance. This piercing can be worn alone for a minimal look or paired with multiple dermals for a more dramatic and customized style. Our specialists take the time to understand your preferences and guide you in choosing the best placement and jewelry design to suit your body structure and aesthetic goals.
          </p>

          <p>
            The procedure is typically quick and efficient, making it convenient even for clients with busy schedules. Our team uses advanced techniques designed to reduce discomfort and promote effective healing, ensuring that you can enjoy your new piercing with confidence. We also provide high-quality, hypoallergenic dermal jewelry that is safe for sensitive skin, helping to prevent irritation and ensuring a smooth healing process.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels comfortable and confident throughout their visit. We understand that surface piercings can feel intimidating, especially for first-time clients, and our friendly staff is always available to answer your questions and provide reassurance. From consultation to completion, we focus on delivering a positive and stress-free experience tailored to your needs.
          </p>

          <p>
            Aftercare is especially important for chest dermal piercings, and we provide detailed instructions to help you maintain proper care during the healing period. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection, irritation, or displacement. Following proper aftercare is essential for maintaining the longevity and appearance of your dermal piercing.
          </p>

          <p>
            Our chest dermal piercing services in the UAE combine premium quality with transparent pricing, ensuring you receive exceptional value without hidden costs. Booking your appointment is quick and convenient, allowing you to choose a time that fits your schedule. We aim to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted chest dermal piercing services in the UAE for a safe, hygienic, and professional experience. With skilled specialists, precise techniques, and a strong commitment to customer satisfaction, we help you achieve a unique and elegant body look effortlessly. Book your chest dermal piercing appointment today and elevate your style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Chest Dermal Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default ChestDermalPiercing;